import React, { useEffect, useState } from 'react'
import { CommonAxiosGet } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import Header from '../../../Header/Header';
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
import * as jnb from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { CommonReactTable } from '../../../CommonUtils/CommonTable/CommonReactTable';
import { FaHandPointRight } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';

export default function EstablishmentRegReport() {
  const loginreducer = useSelector((state) => state?.reducers?.loginreducer?.loginDetails?.loginData);
  let location = useLocation()
  let org_id = location?.state?.org_id
  let status = location?.state?.status
  let navigate = useNavigate()

  const [showList, setList] = useState([])

  // function GetChequeInReport() {
  //   let url = config.url.BOC_URL + "establishment/mandalAndRegTypeWise?mandal_code=" + org_id + "&registered_by=" + status;
  //   CommonAxiosGet(url).then((response) => {
  //     if (response.data.status === true) {
  //       setList(response.data.details);
  //     }
  //     else {
  //       setList([])
  //     }
  //   })
  // }
  const { data: mandalAndRegTypeWise } = useQuery({
    queryKey: ['mandalAndRegTypeWise', status, org_id],
    queryFn: () => CommonAxiosGet(config.url.BOC_URL + "establishment/mandalAndRegTypeWise?mandal_code=" + org_id + "&registered_by=" + status),
    staleTime: 5 * 60 * 1000, // 5min
    // enabled: !!org_id, // Only fetch if org_id is truthy
  });
  useEffect(() => {
    if (mandalAndRegTypeWise?.data?.status === true) {
      setList(mandalAndRegTypeWise.data.details);
    } else if (mandalAndRegTypeWise) {
      setList([]);
    }
  }, [mandalAndRegTypeWise]);
  // useEffect(() => { GetChequeInReport() }, [])
  const columns = [
    {
      Header: 'S.NO',
      accessor: (row, index) => index + 1,
      Footer: 'Total',

    },
    {
      Header: 'Establishment ID',
      accessor: 'est_reg_id',
      Cell: ({ row }) =>
      (<span style={{ color: 'Highlight', textDecoration: 'underline' }}
        onClick={() => {
          navigate('/EstablishmentReport', { state: { data: row.original } })
        }}>{row?.original?.est_reg_id}</span>),
      Footer: '',
    },
    {
      Header: 'Establishment Name',
      accessor: 'establishment_name',
      Footer: '',
    },
    {
      Header: 'Address / Location',
      accessor: (row) =>
      (<span>{row?.postal_address}, Door No-{row?.postal_door_no} ,
        {row?.postal_village_name},
        {row?.postal_mandal_name} ,
        {row?.postal_district_name} dist.,
        {row?.postal_pincode}</span>),
      Footer: '',
    },
    {
      Header: 'Estimated Cost ',
      accessor: 'est_cost_of_construct',
      Footer: 'est_cost_of_construct',
    },
    {
      Header: 'Cess Payment',
      accessor: 'Cess Payment',
      columns: [{
        Header: 'Total',
        accessor: 'tot_cess',
        Footer: 'tot_cess',
      },
      {
        Header: 'Received',
        accessor: 'cess_paid',
        Footer: 'cess_paid',
      },
      {
        Header: 'To be Received',
        accessor: 'cess_to_be_paid',
        Footer: 'cess_to_be_paid',
      },],
      Footer: '',
    },



  ]
  return (
    <React.Fragment>
      <Header />
      <div className="main_section"> </div>
      <CommonPageHeading heading="Establishment Report" />
      <jnb.Container className="outer-page-content-container">
        <div className="px-2 mt-1 text-right" onClick={() => navigate("/EstablishmentApplication", { state: { status: "ALO", username: loginreducer?.username } })}>
          <FaHandPointRight size={25} color='#ffb366'></FaHandPointRight> &nbsp;
          <i className="badge badge-success forgot mb-1 fw-bold " data-toggle="tooltip" animation="true" title="Registration For Workers!"
          > New Registration</i>
        </div>
        <div className="table-responsive">
          <CommonReactTable columns={columns} data={showList} showFooter="true" filename="DepartmentReport" />
        </div>
      </jnb.Container>
    </React.Fragment>
  )
}
